import React from 'react';
import { Outlet } from 'react-router-dom';

const SectionsHome = () => {
  return (
    <section className="app-route">
      <Outlet />
    </section>
  );
};

export default SectionsHome;